import {
    EuiHeaderSection,
    EuiHeaderSectionItem,
    EuiSwitch,
    EuiText,
    EuiSelect,
    EuiShowFor,
    EuiHideFor,
} from "@elastic/eui";
import React, { useEffect, useState } from "react";
import Logout from "../logout";
import logoPng from "./logo.png";
import * as S from "./style";
import Breadcrumbs from "../breadcrumbs";
import HeaderAppMenu from "./headerAppMenu";
import * as localStorage from "../../../../lib/localStorage";

const renderLogo = () => <S.Logo src={logoPng} />;

const renderLogout = () => {
    const isAuthenticated =
        localStorage.getItem("accessToken") !== null &&
        localStorage.getItem("accessToken") !== "null";
    return isAuthenticated && <Logout />;
};

const lang = localStorage.getItem("locale");
const theme = localStorage.getItem("theme");
const getThemeText = (isDark) => (isDark ? "dark" : "light");

function Header() {
    const [isDarkTheme, setIsDarkTheme] = useState(theme === "dark");
    const [locale, setLocale] = useState(lang || "en");

    useEffect(() => {
        if (getThemeText(isDarkTheme) !== theme) {
            localStorage.setItem("theme", getThemeText(isDarkTheme));
            window.location.reload();
        }
    }, [isDarkTheme]);

    useEffect(() => {
        if (locale !== lang) {
            localStorage.setItem("locale", locale);
            window.location.reload();
        }
    }, [locale]);

    const toggleTheme = (flag) => {
        setIsDarkTheme(flag);
    };

    const onLocaleChange = (value) => {
        setLocale(value);
    };

    return (
        <S.StyledHeader
            position="fixed"
            alignItems="center"
        >
            <S.HeaderContent>
                <EuiHeaderSection>
                    <EuiHeaderSectionItem border="right">{renderLogo()}</EuiHeaderSectionItem>
                    <S.StyledText>
                        <div className="brand-name">
                            Control <b>Center</b>
                        </div>
                    </S.StyledText>
                    <Breadcrumbs />
                </EuiHeaderSection>
                <div style={{ flexGrow: 1 }} />
                <EuiShowFor sizes={["xl", "l"]}>
                    <EuiHeaderSection className="eui-hideFor--m">
                        <EuiHeaderSectionItem
                            border="none"
                            style={{ marginInlineEnd: 10 }}
                        >
                            <EuiSelect
                                options={[
                                    { value: "en", text: "English" },
                                    { value: "ar", text: "عربي" },
                                ]}
                                value={locale}
                                onChange={(e) => onLocaleChange(e.target.value)}
                            />
                        </EuiHeaderSectionItem>
                        <EuiHeaderSectionItem
                            border="none"
                            style={{ marginInlineEnd: 10 }}
                        >
                            <EuiSwitch
                                label="Dark mode"
                                checked={isDarkTheme}
                                onChange={(e) => toggleTheme(e.target.checked)}
                                compressed
                            />
                        </EuiHeaderSectionItem>
                        <EuiHeaderSectionItem border="left">{renderLogout()}</EuiHeaderSectionItem>
                    </EuiHeaderSection>
                </EuiShowFor>
                <EuiHideFor sizes={["xl", "l"]}>
                    <HeaderAppMenu />
                </EuiHideFor>
            </S.HeaderContent>
        </S.StyledHeader>
    );
}

export default Header;
